import * as Yup from 'yup';

export const initialValues = (hasCustomField) => {
  const baseValues = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    dateOfBirth: new Date(),
    country: '',
    date: new Date(),
    timeSlot: '',
  };

  let customFieldValue = {};

  if (hasCustomField) {
    customFieldValue = {
      customFieldValue: '',
    };
  }

  return { ...baseValues, ...customFieldValue };
};

export const validationSchema = (hasCustomField) => {
  const baseFields = {
    firstName: Yup.string().required('field is required'),
    lastName: Yup.string().required('field is required'),
    email: Yup.string().required('field is required'),
    phone: Yup.string(),
    dateOfBirth: Yup.date(),
    date: Yup.date().required('field is required'),
    timeSlot: Yup.object()
      .shape({
        key: Yup.number(),
        start_date: Yup.string(),
        end_date: Yup.string(),
      })
      .required('field is required'),
  };

  let customField = {};

  if (hasCustomField) {
    customField = {
      customFieldValue: Yup.string().required('field is required'),
    };
  }

  return Yup.object().shape({
    ...baseFields,
    ...customField,
  });
};
